export default __webpack_public_path__ + "static/ef-partner-logo-6af4b39b8fb4634ed2565d23f4604fa1.png";